import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../../common/withRouter';
import { Image } from "../Facility";
import {
  Notification,
  Message,
  ButtonOBSOLETED
} from '../../../web.common';
import withApi from '../../higherOrderComponents/withApi';
import { DetailsRightBar, Divider, NoLink } from '../DetailsRightBar';
import PageTop from '../../layout/PageTop';
import { SchemeSelectorHook } from './sections/SchemeSelectorHook';
import AsyncSelect from "react-select/async";
import ReactSelect from 'react-select';
import { mappedPriceLevels } from '../../../enums/PriceLevels';
import { validateForm } from './BookingDetails';
import { mappedGroupHeaders } from "./BookingDetails";
import RichTextEditor from '../../misc/RichTextEditor';

const CreateBookingInternal = ({
  api,
  match,
  categories,
  currencies,
  history
}) => {

const productTypes = [{ value: 'Booking', label: 'Booking' }, { value: 'Membership', label: 'Membership' }];

  const formLabelStyle = {
    display: "table-cell",
    width: "30%",
    whiteSpace: "nowrap",
    fontWeight: "bold",
    verticalAlign: "top",
  };

  const formSpanStyle = {
    display: "table-cell",
  };

  const rowStyle = {
    display: "table",
    width: "100%",
    margin: "auto",
    marginBottom: "0"
  };

  const inputStyle = { marginLeft: '0%' }

  const containerStyle = {
    width: '80%',
    margin: 'auto',
    backgroundColor: 'white',
    border: "1px solid #e5e5e5",
    padding: "1.2rem"
  };

  const textAreaStyle = {
    width: '100%'
  };

  const initialValue = {
    Type: 'Booking',
    Name: '',
    Description: '',
    Summary: '',
    Description: '',
    PurchaseText: '',
    ExternalLink: '',
    TermsOfServiceLink: '',
    ConditionText: '',
    Type: 'Booking',
    Provider: null,
    Category: 'None',
    SubType: null,
    SchemeName: null,
    Slug: '',
    PicturePreview: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAADCAYAAABbNsX4AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAASUlEQVR4nGORMA36rywnxXD19kMGfj5uBmEBPgYWBWkJBlUFGYYQTzuGF6/fMRw9e5WB5ezV2wz/GRgY9h0/z8DLw8XAwszEAAAl8BGj0uhjlQAAAABJRU5ErkJggg==',
    IsVisible: true,
    IsExclusive: false,
    IsClassActivity: false,
    IsBundleEnabled: false,
    Photos: {
      SquareUrl: '7c2f125f-b311-4ac1-b698-1ef6b753455b-squared',
      BannerUrl: '1ee9d569-4a6d-4e2e-b325-300b946f9923-list',
      HugeUrl: 'ab7687a7-6ad0-48a9-a2c0-6c68850a5691-huge',
      ListUrl: '1ee9d569-4a6d-4e2e-b325-300b946f9923-list',
      ListPreviewUrl: '62def2d9-faa8-407e-ac20-30a06fba817a-list-preview',
      SquarePreviewUrl: '40795af1-8f6f-4d65-842d-e6329b24d5f8-squared-preview',
      HugePreviewUrl: 'bbf96340-d71f-488b-86be-ff2394c901b2-huge-preview',
    },
    Price: {
      Amount: '',
      TaxAmount: '',
      CurrencyIsoCode: '',
      ServiceFeeAmount: 0,
      Level: '',
      TaxIndex: {
        AsDecimal: 0.0
      }
    },
    SignUpDeadLine: '01:00:00',
    SignUpCancellationDeadline: '01:00:00',
    MaxSignUpInAdvanceInDays: null,
    ProductFeature: {
      CourtType: {
        ClayCourt: false,
        AsphaltCourt: false,
        ArtificialGrassCourt: false,
        ArtificialClayCourt: false,
        HardCourt: false
      },
      Amenities: {
        DressingRooms: false,
        FreeParking: false,
        EquipmentRental: false,
        EquipmentIncluded: false
      },
      Coverage: {
        Indoor: false,
        Outdoor: false,
        OutdoorWithCover: false
      },
      HallType: {
        Multihall: false,
        BadmintonHall: false,
      },
      Size: {
        NormalSize: false,
        MiniTennisSize: false,
        Single: false,
        Double: false
      }
    },
    Group: '',
    GroupHeader: mappedGroupHeaders[0].value,
    Facility: null,
    GroupId: '',
    SortingPreference: 0,
    SubType: null,
    ServiceFeeAmount: 0
  }

  const [editingContent, doEdit] = useState(initialValue);
  const [editedNotification, setNotification] = useState(null);
  const [subTypeMapped, setSubTypeMapped] = useState(null);
  const [picturePreviewEditAsBase64, setPicturePreviewAsBase64Edit] = useState('');

  useEffect(() => {
    async function loadFromApi() {
      const subTypesResponse = await api.products.getSubTypes();
      setSubTypeMapped(subTypesResponse.map((x) => ({ value: x.id, label: x.name })));
    }

    if (!subTypeMapped) {
      loadFromApi();
    }
  }, [subTypeMapped])

  const lookupFacility = (value) => {
    const result = api.facilities.lookupByNameOrId(value);
    return result;
  }

  const handlePicture = async (picture) => {
    if (picture.length > 5) {
      var preview = await api.products.generatePreview(picture);
      setPicturePreviewAsBase64Edit(preview);
    } else {
      setPicturePreviewAsBase64Edit('');
    }
  }

  const lookupProvider = (value) => {
    const result = api.providers.lookupByNameOrId(value);
    return result;
  }

  const mappedProdutFeatureByType = (featuresByType) => {
    const courtOptions = Object.keys(featuresByType).map(feature => ({
      label: feature,
      value: featuresByType[feature],
    }));

    return courtOptions;
  }

  const mappedAmenities = (amenities) => {
    const courtOptions = Object.keys(amenities).map(x => ({
      label: x,
      value: x,
      isSelected: amenities[x]
    }));

    return courtOptions;
  }

  const handleSchemeChange = (selectedScheme) => {
    doEdit((prevContent) => ({
      ...prevContent,
      SchemeName: selectedScheme,
    }));
  };

  const handleProductFeatureSetting = (groupName, selectedType) => {

    let selectedTypeAsArray;
    if (Array.isArray(selectedType)) {
      selectedTypeAsArray = selectedType;
    } else if (typeof selectedType === 'object') {
      selectedTypeAsArray = [selectedType]
    }

    let formattedGroup = editingContent.ProductFeature[groupName];
    Object.keys(formattedGroup).forEach(x => formattedGroup[x] = false);
    if (selectedType != null && selectedTypeAsArray.length > 1) {
      for (const element of selectedTypeAsArray) {
        formattedGroup[element.label] = true;
      }
    } else if (selectedType != null && selectedTypeAsArray.length == 1) {
      formattedGroup[selectedTypeAsArray[0].label] = true;
    }

    doEdit({
      ...editingContent,
      ProductFeature: {
        ...editingContent.ProductFeature,
        [groupName]: formattedGroup,
      },
    });
  }

  const createProduct = async (event, receivedProps) => {
    const validationResponse = validateForm(receivedProps);

    if (validationResponse.success == false) {
      event.preventDefault();
      setNotification(new Message(validationResponse.type, validationResponse.message));
      return;
    }

    try {
      const response = await api.products.createBooking(receivedProps);
      history.push(`/product/details/${response.Id}`);
      
    } catch (error) {
      setNotification(new Message('error', `Unable to create the booking. ${error}`));
    }
  }

  const mappedCurrencies = currencies.map(({ Name }) => ({ value: Name, label: Name }));
  const mappedCategories = categories.map(({ Name: categoryName }) => ({ value: categoryName, label: categoryName }));

  return (
    <React.Fragment>
      <Notification newMessage={editedNotification} />
      <div className='content-with-right-pane-delimiter'>
        <PageTop
          documentTitle={`Booking create page`}
          documentDescription={`Booking create page`}
        />

        <h2 className='main-page-header main-page-header-with-subheader'>
          Product
        </h2>
        <h5 className='main-page-subheader'><i>New Product</i></h5>
        <br />

        <>
          <div style={containerStyle}>
          <div style={rowStyle}>
              <label for="group-header" style={formLabelStyle}>
                Product Type
              </label>
              <span style={formSpanStyle}>
                <ReactSelect
                  className="react-select-filters-section"
                  classNamePrefix="react-select-filters-section-prefix"
                  value={productTypes.filter(
                    (x) => x.value == editingContent.Type
                  )}
                  onChange={(selection) => {
                    console.log(selection);
                    doEdit({
                      ...editingContent,
                      Type: selection.value
                    });
                  }}
                  options={productTypes}
                ></ReactSelect>
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="name" style={formLabelStyle}>{"Name*"}</label>
              <span style={formSpanStyle} >
                <input style={inputStyle} name="name" id="name"

                  placeholder='Name'
                  value={editingContent.Name}
                  onChange={({ target }) => doEdit({ ...editingContent, Name: console.log(target.value) || target.value })} />
              </span>
            </div>
            <hr />
            <hr />
            <div style={rowStyle}>
              <label for="provider" style={formLabelStyle}>
                {'Provider*'}
              </label>
              <span style={formSpanStyle}>
                <AsyncSelect
                  className="react-select-filters-section"
                  classNamePrefix="react-select-filters-section-prefix"
                  defaultOptions
                  value={editingContent.Provider}
                  cacheOptions
                  onChange={(selection) =>
                    doEdit({
                      ...editingContent,
                      Provider: console.log(selection) || selection,
                    })
                  }
                  loadOptions={async (inputValue) => lookupProvider(inputValue)}
                ></AsyncSelect>
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="facility" style={formLabelStyle}>
                {'Facility*'}
              </label>
              <span style={formSpanStyle}>
                <AsyncSelect
                  className="react-select-filters-section"
                  classNamePrefix="react-select-filters-section-prefix"
                  defaultOptions
                  value={editingContent.Facility}
                  cacheOptions
                  onChange={(selection) =>
                    doEdit({
                      ...editingContent,
                      Facility: console.log(selection) || selection,
                    })
                  }
                  loadOptions={async (inputValue) => lookupFacility(inputValue)}
                ></AsyncSelect>
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="group-header" style={formLabelStyle}>
                Group Header
              </label>
              <span style={formSpanStyle}>
                <ReactSelect
                  className="react-select-filters-section"
                  classNamePrefix="react-select-filters-section-prefix"
                  value={mappedGroupHeaders.filter(
                    (x) => x.value == editingContent.GroupHeader
                  )}
                  onChange={(selection) => {
                    console.log(selection);
                    doEdit({
                      ...editingContent,
                      GroupHeader: selection.value
                    });
                  }}
                  options={mappedGroupHeaders}
                ></ReactSelect>
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="summary" style={formLabelStyle}>{'Summary*'}</label>
              <span style={formSpanStyle} >
                <textarea style={textAreaStyle} rows={2} name="summary" id="summary"
                  placeholder='Summary'
                  value={editingContent.Summary}
                  onChange={({ target }) => doEdit({ ...editingContent, Summary: console.log(target.value) || target.value })}
                >
                </textarea>
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="description" style={formLabelStyle}>Description</label>
              <span style={formSpanStyle} >
                <RichTextEditor
                  value={editingContent.Description}
                  onChange={(content) => doEdit({ ...editingContent, Description: content })}
                  placeholder='Description'
                />
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="purchaseText" style={formLabelStyle}>Purchase Text</label>
              <span style={formSpanStyle} >
                <RichTextEditor
                  value={editingContent.PurchaseText}
                  onChange={(content) => doEdit({ ...editingContent, PurchaseText: content })}
                  placeholder='Purchase Text'
                />
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="category" style={formLabelStyle}>
                Category
              </label>
              <span style={formSpanStyle}>
                <ReactSelect
                  className="react-select-filters-section"
                  classNamePrefix="react-select-filters-section-prefix"
                  value={mappedCategories.filter(
                    (x) => x.label == editingContent.Category
                  )}
                  onChange={(selection) => {
                    doEdit({
                      ...editingContent,
                      Category: console.log(selection) || (selection ? selection.value : "None"),
                    });
                  }}
                  options={mappedCategories}
                ></ReactSelect>
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="subtype" style={formLabelStyle}>
                SubType
              </label>
              <span style={formSpanStyle}>
                <ReactSelect
                  isClearable={true}
                  className="react-select-filters-section"
                  classNamePrefix="react-select-filters-section-prefix"
                  value={editingContent.SubType && subTypeMapped.filter(
                    (x) => x.value == editingContent.SubType.Id
                  )}
                  onChange={(selection) => {
                    console.log(selection);
                    doEdit({
                      ...editingContent,
                      SubType:
                      {
                        ...editingContent.Subtype,
                        Id: selection ? selection.value : undefined
                      }
                    });
                  }}
                  options={subTypeMapped}
                ></ReactSelect>
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="subtype" style={formLabelStyle}>
                Scheme
              </label>
              <span style={formSpanStyle}>
                <SchemeSelectorHook
                  category={editingContent.Category}
                  content={editingContent}
                  onSchemeChange={handleSchemeChange}
                />
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="is-visible" style={formLabelStyle}>
                Is Visible
              </label>
              <span style={formSpanStyle}>
                <input
                  type="checkbox"
                  checked={editingContent.IsVisible}
                  onChange={(e) => {
                    console.log(e.target)
                    doEdit({ ...editingContent, IsVisible: e.target.checked });
                  }}
                />
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="is-exclusive" style={formLabelStyle}>
                Is Exclusive
              </label>
              <span style={formSpanStyle}>
                <input
                  type="checkbox"
                  checked={editingContent.IsExclusive}
                  onChange={(e) => {
                    doEdit({ ...editingContent, IsExclusive: e.target.checked });
                  }}
                />
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="is-class-activity" style={formLabelStyle}>
                Is Class Activity
              </label>
              <span style={formSpanStyle}>
                <input
                  type="checkbox"
                  checked={editingContent.IsClassActivity}
                  onChange={(e) => {
                    doEdit({ ...editingContent, IsClassActivity: e.target.checked });
                  }}
                />
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="is-bundle-enabled" style={formLabelStyle}>
                Is Bundle Enabled
              </label>
              <span style={formSpanStyle}>
                <input
                  type="checkbox"
                  checked={editingContent.IsBundleEnabled}
                  onChange={(e) => {
                    doEdit({ ...editingContent, IsBundleEnabled: e.target.checked });
                  }}
                />
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="external-link" style={formLabelStyle}>External Link</label>
              <span style={formSpanStyle} >
                <input style={inputStyle} name="external-link" id="external-link"
                  placeholder='External Link'
                  value={editingContent.ExternalLink}
                  onChange={({ target }) => {
                    doEdit({ ...editingContent, ExternalLink: target.value })
                  }} />
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="terms-of-service-link" style={formLabelStyle}>Terms Of Service Link </label>
              <span style={formSpanStyle} >
                <input style={inputStyle} name="terms-of-service-link" id="terms-of-service-link"
                  placeholder='Terms Of Service Link'
                  value={editingContent.TermsOfServiceLink}
                  onChange={({ target }) => doEdit({ ...editingContent, TermsOfServiceLink: console.log(target.value) || target.value })} />
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="condition-text" style={formLabelStyle}>Condition Text</label>
              <span style={formSpanStyle} >
                <input style={inputStyle} name="condition-text" id="condition-text"
                  placeholder='Condition Text'
                  value={editingContent.ConditionText}
                  onChange={({ target }) => doEdit({ ...editingContent, ConditionText: console.log(target.value) || target.value })} />
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="sorting-preference" style={formLabelStyle}>Sorting Preference</label>
              <span style={formSpanStyle} >
                <input style={inputStyle} name="sorting-preference" id="sorting-preference"
                  placeholder='Sorting Preference'
                  value={editingContent.SortingPreference}
                  onChange={({ target }) => {
                    console.log(target.value);
                    doEdit({ ...editingContent, SortingPreference: target.value.trim() })
                  }} />
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="slug" style={formLabelStyle}>Slug</label>
              <span style={formSpanStyle} >
                <input style={inputStyle} name="slug" id="slug"
                  placeholder='Slug'
                  value={editingContent.Slug}
                  onChange={({ target }) => doEdit({ ...editingContent, Slug: console.log(target.value) || target.value })} />
              </span>
            </div>
          </div>
          <br />
          <h4 className='main-page-subheader'>Price</h4>
          <br />
          <div style={containerStyle}>
            <div style={rowStyle}>
              <label for="amount" style={formLabelStyle}>{"Amount*"}</label>
              <span style={formSpanStyle} >
                <input style={inputStyle} name="amount" id="amount"
                  placeholder='Amount'
                  value={editingContent.Price.Amount}
                  onChange={({ target }) => doEdit(
                    {
                      ...editingContent, Price: {
                        ...editingContent.Price,
                        Amount: console.log(target.value) || target.value
                      }
                    })} />
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="currency-iso-code" style={formLabelStyle}>
                {'Currency Iso Code*'}
              </label>
              <span style={formSpanStyle}>
                <ReactSelect
                  className="react-select-filters-section"
                  classNamePrefix="react-select-filters-section-prefix"
                  value={mappedCurrencies.filter(
                    (x) => x.label == editingContent.Price.CurrencyIsoCode
                  )}
                  onChange={(selection) => {
                    console.log(selection.value);
                    doEdit({
                      ...editingContent,
                      Price: {
                        ...editingContent.Price,
                        CurrencyIsoCode: selection ? selection.value : "None"
                      },
                    });
                  }}
                  options={mappedCurrencies}
                ></ReactSelect>
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="tax-index" style={formLabelStyle}>Tax Index</label>
              <span style={{ ...formSpanStyle, width: '85%' }} >
                <input
                  style={inputStyle}
                  name="tax-index"
                  id="tax-index"
                  placeholder='Tax Index'
                  value={editingContent.Price.TaxIndex.AsDecimal}
                  onChange={({ target }) => {
                    console.log(target)
                    doEdit(
                      {
                        ...editingContent, Price: {
                          ...editingContent.Price, TaxIndex: {
                            ...editingContent.Price.TaxIndex,
                            AsDecimal: target.value || ''
                          }
                        }
                      })
                  }} />
              </span>{' %'}
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="fee" style={formLabelStyle}>Service Fee Amount</label>
              <span style={formSpanStyle} >
                <input style={inputStyle} name="fee" id="fee"
                  placeholder='Service Fee Amount'
                  type="number"
                  value={editingContent.Price.ServiceFeeAmount}
                  onChange={({ target }) => doEdit(
                    {
                      ...editingContent, Price: {
                        ...editingContent.Price, ServiceFeeAmount: console.log(target.value) || target.value
                      }
                    })} />
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="price-level" style={formLabelStyle}>
                {'Price Level'}
              </label>
              <span style={formSpanStyle}>
                <ReactSelect
                  className="react-select-filters-section"
                  classNamePrefix="react-select-filters-section-prefix"
                  value={mappedPriceLevels.filter(
                    (x) => x.label == editingContent.Price.Level
                  )}
                  onChange={(selection) => {
                    console.log(selection);
                    doEdit({
                      ...editingContent,
                      Price: {
                        ...editingContent.Price,
                        Level: selection.value
                      },
                    });
                  }}
                  options={mappedPriceLevels}
                ></ReactSelect>
              </span>
            </div>
          </div>
          <br />
          {
          editingContent.Type == 'Membership' ? '' : 
          <>
            <h4 className='main-page-subheader'>Booking</h4>
            <br />
            <div style={containerStyle}>
              <div style={rowStyle}>
                <label for="signup-deadline" style={formLabelStyle}>{'Signup Deadline*'}</label>
                <span style={formSpanStyle} >
                  <input style={inputStyle}
                    value={editingContent.SignUpDeadLine}
                    placeholder="Signup Deadline"
                    onChange={(e) => {
                      console.log(e.target.value);
                      doEdit({ ...editingContent, SignUpDeadLine: e.target.value == "" ? null : e.target.value });
                    }}
                  ></input>
                </span>
              </div>
              <hr />
              <div style={rowStyle}>
                <label for="signup-cancellation-deadline" style={formLabelStyle}>{'Signup Cancellation Deadline*'}</label>
                <span style={formSpanStyle} >
                  <input style={inputStyle}
                    value={editingContent.SignUpCancellationDeadline}
                    placeholder="Signup Cancellation Deadline"
                    onChange={(e) => {
                      console.log(e.target.value);
                      doEdit({ ...editingContent, SignUpCancellationDeadline: e.target.value == "" ? null : e.target.value });
                    }}
                  ></input>
                </span>
              </div>
              <hr />
              <div style={rowStyle}>
                <label for="bundle-deadline" style={formLabelStyle}>{'Bundle Deadline'}</label>
                <span style={formSpanStyle} >
                  <input style={inputStyle}
                    value={editingContent.BundleDeadline || ''}
                    placeholder="Bundle Deadline (empty = cancellation deadline + 4h)"
                    onChange={(e) => {
                      doEdit({ ...editingContent, BundleDeadline: e.target.value == "" ? null : e.target.value });
                    }}
                  ></input>
                </span>
              </div>
              <hr />
              <div style={rowStyle}>
                <label for="max-sign-up-in-advance-in-days" style={formLabelStyle}>Max Sign Up In Advance In Days</label>
                <span style={formSpanStyle} >
                  <input style={inputStyle}
                    value={editingContent.MaxSignUpInAdvanceInDays}
                    placeholder="Max Sign Up In Advance In Days"
                    onChange={(e) => {
                      console.log(e.target.value);
                      doEdit({ ...editingContent, MaxSignUpInAdvanceInDays: e.target.value == "" ? null : e.target.value });
                    }}
                  ></input>
                </span>
              </div>
            </div>
            <br />
            <h4 className='main-page-subheader'>Product Features</h4>
            <br />
            <div style={containerStyle}>
              <div style={rowStyle}>
                <label for="court-type" style={formLabelStyle}>
                  Court Type
                </label>
                <span style={formSpanStyle}>
                  <ReactSelect
                    className="react-select-filters-section"
                    classNamePrefix="react-select-filters-section-prefix"
                    isClearable={true}
                    value={mappedProdutFeatureByType(editingContent.ProductFeature.CourtType).find(
                      (x) => x.value === true)}
                    onChange={(selection) => {
                      console.log(selection);
                      handleProductFeatureSetting("CourtType", selection)
                    }}
                    options={mappedProdutFeatureByType(editingContent.ProductFeature.CourtType)}
                  ></ReactSelect>
                </span>
              </div>
              <hr />
              <div style={rowStyle}>
                <label for="amenities" style={formLabelStyle}>
                  Amenities
                </label>
                <span style={formSpanStyle}>
                  <ReactSelect
                    isMulti
                    className="react-select-filters-section"
                    classNamePrefix="react-select-filters-section-prefix basic-multi-select"
                    defaultValue={mappedAmenities(editingContent.ProductFeature.Amenities).filter(
                      (x) => x.isSelected === true)}
                    onChange={(selection) => {
                      console.log(selection);
                      handleProductFeatureSetting("Amenities", selection)
                    }}
                    options={mappedAmenities(editingContent.ProductFeature.Amenities)}
                  ></ReactSelect>
                </span>
              </div>
              <hr />
              <div style={rowStyle}>
                <label for="coverage" style={formLabelStyle}>
                  Coverage
                </label>
                <span style={formSpanStyle}>
                  <ReactSelect
                    className="react-select-filters-section"
                    classNamePrefix="react-select-filters-section-prefix"
                    isClearable={true}
                    value={mappedProdutFeatureByType(editingContent.ProductFeature.Coverage).find(
                      (x) => x.value === true)}
                    onChange={(selection) => {
                      console.log(selection);
                      handleProductFeatureSetting("Coverage", selection)
                    }}
                    options={mappedProdutFeatureByType(editingContent.ProductFeature.Coverage)}
                  ></ReactSelect>
                </span>
              </div>
              <hr />
              <div style={rowStyle}>
                <label for="hall-type" style={formLabelStyle}>
                  Hall Type
                </label>
                <span style={formSpanStyle}>
                  <ReactSelect
                    className="react-select-filters-section"
                    classNamePrefix="react-select-filters-section-prefix"
                    isClearable={true}
                    value={mappedProdutFeatureByType(editingContent.ProductFeature.HallType).find(
                      (x) => x.value === true)}
                    onChange={(selection) => {
                      console.log(selection);
                      handleProductFeatureSetting("HallType", selection)
                    }}
                    options={mappedProdutFeatureByType(editingContent.ProductFeature.HallType)}
                  ></ReactSelect>
                </span>
              </div>
              <hr />
              <div style={rowStyle}>
                <label for="size" style={formLabelStyle}>
                  Size
                </label>
                <span style={formSpanStyle}>
                  <ReactSelect
                    className="react-select-filters-section"
                    classNamePrefix="react-select-filters-section-prefix"
                    isClearable={true}
                    value={mappedProdutFeatureByType(editingContent.ProductFeature.Size).find(
                      (x) => x.value === true)}
                    onChange={(selection) => {
                      console.log(selection);
                      handleProductFeatureSetting("Size", selection)
                    }}
                    options={mappedProdutFeatureByType(editingContent.ProductFeature.Size)}
                  ></ReactSelect>
                </span>
              </div>
            </div>
          </>
          }
          <div style={{ 'display': 'flex', 'justifyContent': 'center', 'marginTop': '2%' }}>
            <br />
            <br />
            <div style={{ marginRight: '2%' }}>
              <ButtonOBSOLETED
                type="submit"
                buttonContent="Save"
                onClick={async (e) => {
                  await createProduct(e, editingContent);
                }} />
            </div>

          </div>
        </>
        <DetailsRightBar>
          <Divider>Links</Divider>
          <NoLink>None</NoLink>
          <Divider>Actions</Divider>
          <NoLink>None</NoLink>
        </DetailsRightBar>
      </div>
    </React.Fragment>
  );
}

const CreateBooking = withRouter(withApi(
  connect(({ user, categories, currencies }) =>
    ({ isLoggedIn: !!user, categories, currencies }), {})(CreateBookingInternal)
));

CreateBooking.requiresLogin = true;
CreateBooking.propTypes = { isLoggedIn: PropTypes.bool };

export default CreateBooking;